import React from 'react';
import EngineScene from './EngineScene';
import chronotunnel from '../intro-engine/chronotunnel';

// gb4k.fr V2 Chronotunnel — a letter-tunnel flight, rendered by the V2 engine.
const ChronotunnelVisualization: React.FC = () => <EngineScene make={chronotunnel} />;
export default ChronotunnelVisualization;
